/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.Score.Query
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Any
 */
export interface Any {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof Any
     */
    '@type': string;
}
/**
 * 
 * @export
 * @interface FetchReplay
 */
export interface FetchReplay {
    /**
     * 
     * @type {string}
     * @memberof FetchReplay
     */
    'error'?: string;
    /**
     * 
     * @type {Array<SecurityQueryResult>}
     * @memberof FetchReplay
     */
    'securityQueryResult'?: Array<SecurityQueryResult>;
}
/**
 * 
 * @export
 * @interface FetchRequest
 */
export interface FetchRequest {
    /**
     * 
     * @type {Array<SecurityQuery>}
     * @memberof FetchRequest
     */
    'queries'?: Array<SecurityQuery>;
}
/**
 * 
 * @export
 * @interface PeerGauge
 */
export interface PeerGauge {
    /**
     * 
     * @type {number}
     * @memberof PeerGauge
     */
    'sourceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeerGauge
     */
    'peerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeerGauge
     */
    'gauageFieldId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeerGauge
     */
    'currencyId'?: number;
}
/**
 * 
 * @export
 * @interface PeerGaugeReplay
 */
export interface PeerGaugeReplay {
    /**
     * 
     * @type {Array<PeerGaugeResult>}
     * @memberof PeerGaugeReplay
     */
    'peerGaugeResult'?: Array<PeerGaugeResult>;
    /**
     * 
     * @type {string}
     * @memberof PeerGaugeReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface PeerGaugeRequest
 */
export interface PeerGaugeRequest {
    /**
     * 
     * @type {Array<PeerGauge>}
     * @memberof PeerGaugeRequest
     */
    'queries'?: Array<PeerGauge>;
}
/**
 * 
 * @export
 * @interface PeerGaugeResult
 */
export interface PeerGaugeResult {
    /**
     * 
     * @type {number}
     * @memberof PeerGaugeResult
     */
    'peerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeerGaugeResult
     */
    'gaugeFieldId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeerGaugeResult
     */
    'currencyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeerGaugeResult
     */
    'average'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeerGaugeResult
     */
    'last'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeerGaugeResult
     */
    'max'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeerGaugeResult
     */
    'min'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PeerGaugeResult
     */
    'hasValue'?: boolean;
}
/**
 * 
 * @export
 * @interface PeerHistory
 */
export interface PeerHistory {
    /**
     * 
     * @type {number}
     * @memberof PeerHistory
     */
    'sourceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeerHistory
     */
    'peerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeerHistory
     */
    'fieldId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeerHistory
     */
    'currencyId'?: number;
}
/**
 * 
 * @export
 * @interface PeerHistoryReplay
 */
export interface PeerHistoryReplay {
    /**
     * 
     * @type {Array<PeerHistoryResult>}
     * @memberof PeerHistoryReplay
     */
    'peerHistoryResult'?: Array<PeerHistoryResult>;
    /**
     * 
     * @type {string}
     * @memberof PeerHistoryReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface PeerHistoryRequest
 */
export interface PeerHistoryRequest {
    /**
     * 
     * @type {Array<PeerHistory>}
     * @memberof PeerHistoryRequest
     */
    'queries'?: Array<PeerHistory>;
}
/**
 * 
 * @export
 * @interface PeerHistoryResult
 */
export interface PeerHistoryResult {
    /**
     * 
     * @type {number}
     * @memberof PeerHistoryResult
     */
    'date'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeerHistoryResult
     */
    'value'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PeerHistoryResult
     */
    'hasValue'?: boolean;
}
/**
 * 
 * @export
 * @interface SGaugeReplay
 */
export interface SGaugeReplay {
    /**
     * 
     * @type {Array<SecurityGaugeResult>}
     * @memberof SGaugeReplay
     */
    'securityGaugeResult'?: Array<SecurityGaugeResult>;
    /**
     * 
     * @type {string}
     * @memberof SGaugeReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface SGaugeRequest
 */
export interface SGaugeRequest {
    /**
     * 
     * @type {Array<SecurityGauge>}
     * @memberof SGaugeRequest
     */
    'queries'?: Array<SecurityGauge>;
    /**
     * 
     * @type {string}
     * @memberof SGaugeRequest
     */
    'culture'?: string;
}
/**
 * 
 * @export
 * @interface SHistoryReplay
 */
export interface SHistoryReplay {
    /**
     * 
     * @type {Array<SecurityHistoryResult>}
     * @memberof SHistoryReplay
     */
    'securityHistoryResult'?: Array<SecurityHistoryResult>;
    /**
     * 
     * @type {string}
     * @memberof SHistoryReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface SHistoryRequest
 */
export interface SHistoryRequest {
    /**
     * 
     * @type {Array<SecurityHistory>}
     * @memberof SHistoryRequest
     */
    'queries'?: Array<SecurityHistory>;
}
/**
 * 
 * @export
 * @interface SecurityGauge
 */
export interface SecurityGauge {
    /**
     * 
     * @type {string}
     * @memberof SecurityGauge
     */
    'entityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SecurityGauge
     */
    'gauageFieldId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityGauge
     */
    'currencyId'?: number;
}
/**
 * 
 * @export
 * @interface SecurityGaugeResult
 */
export interface SecurityGaugeResult {
    /**
     * 
     * @type {string}
     * @memberof SecurityGaugeResult
     */
    'entityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SecurityGaugeResult
     */
    'gaugeFieldId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SecurityGaugeResult
     */
    'gaugeFieldName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SecurityGaugeResult
     */
    'currencyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityGaugeResult
     */
    'average'?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityGaugeResult
     */
    'last'?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityGaugeResult
     */
    'max'?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityGaugeResult
     */
    'min'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SecurityGaugeResult
     */
    'hasValue'?: boolean;
}
/**
 * 
 * @export
 * @interface SecurityHistory
 */
export interface SecurityHistory {
    /**
     * 
     * @type {string}
     * @memberof SecurityHistory
     */
    'entityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SecurityHistory
     */
    'fieldId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityHistory
     */
    'currencyId'?: number;
}
/**
 * 
 * @export
 * @interface SecurityHistoryResult
 */
export interface SecurityHistoryResult {
    /**
     * 
     * @type {number}
     * @memberof SecurityHistoryResult
     */
    'date'?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityHistoryResult
     */
    'value'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SecurityHistoryResult
     */
    'hasValue'?: boolean;
}
/**
 * 
 * @export
 * @interface SecurityQuery
 */
export interface SecurityQuery {
    /**
     * 
     * @type {string}
     * @memberof SecurityQuery
     */
    'entityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SecurityQuery
     */
    'scoreFieldId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityQuery
     */
    'currencyId'?: number;
}
/**
 * 
 * @export
 * @interface SecurityQueryResult
 */
export interface SecurityQueryResult {
    /**
     * 
     * @type {string}
     * @memberof SecurityQueryResult
     */
    'entityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SecurityQueryResult
     */
    'scoreFieldId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityQueryResult
     */
    'currencyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SecurityQueryResult
     */
    'value'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SecurityQueryResult
     */
    'hasValue'?: boolean;
}
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {number}
     * @memberof Status
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Any>}
     * @memberof Status
     */
    'details'?: Array<Any>;
}

/**
 * ScoreApi - axios parameter creator
 * @export
 */
export const ScoreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {FetchRequest} [fetchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreFetchDataPost: async (identityToken: string, fetchRequest?: FetchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('scoreFetchDataPost', 'identityToken', identityToken)
            const localVarPath = `/Score/FetchData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SGaugeRequest} [sGaugeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreIGaugeDataPost: async (identityToken: string, sGaugeRequest?: SGaugeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('scoreIGaugeDataPost', 'identityToken', identityToken)
            const localVarPath = `/Score/iGaugeData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sGaugeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SHistoryRequest} [sHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreIHistoryDataPost: async (identityToken: string, sHistoryRequest?: SHistoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('scoreIHistoryDataPost', 'identityToken', identityToken)
            const localVarPath = `/Score/iHistoryData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sHistoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {FetchRequest} [fetchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreIScoreFetchPost: async (identityToken: string, fetchRequest?: FetchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('scoreIScoreFetchPost', 'identityToken', identityToken)
            const localVarPath = `/Score/iScoreFetch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {PeerGaugeRequest} [peerGaugeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scorePeerGaugeDataPost: async (identityToken: string, peerGaugeRequest?: PeerGaugeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('scorePeerGaugeDataPost', 'identityToken', identityToken)
            const localVarPath = `/Score/PeerGaugeData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(peerGaugeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {PeerHistoryRequest} [peerHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scorePeerHistoryDataPost: async (identityToken: string, peerHistoryRequest?: PeerHistoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('scorePeerHistoryDataPost', 'identityToken', identityToken)
            const localVarPath = `/Score/PeerHistoryData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(peerHistoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SGaugeRequest} [sGaugeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreSGaugeDataPost: async (identityToken: string, sGaugeRequest?: SGaugeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('scoreSGaugeDataPost', 'identityToken', identityToken)
            const localVarPath = `/Score/sGaugeData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sGaugeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SHistoryRequest} [sHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreSHistoryDataPost: async (identityToken: string, sHistoryRequest?: SHistoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('scoreSHistoryDataPost', 'identityToken', identityToken)
            const localVarPath = `/Score/sHistoryData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sHistoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScoreApi - functional programming interface
 * @export
 */
export const ScoreApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScoreApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {FetchRequest} [fetchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreFetchDataPost(identityToken: string, fetchRequest?: FetchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreFetchDataPost(identityToken, fetchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SGaugeRequest} [sGaugeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreIGaugeDataPost(identityToken: string, sGaugeRequest?: SGaugeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SGaugeReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreIGaugeDataPost(identityToken, sGaugeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SHistoryRequest} [sHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreIHistoryDataPost(identityToken: string, sHistoryRequest?: SHistoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SHistoryReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreIHistoryDataPost(identityToken, sHistoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {FetchRequest} [fetchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreIScoreFetchPost(identityToken: string, fetchRequest?: FetchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreIScoreFetchPost(identityToken, fetchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {PeerGaugeRequest} [peerGaugeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scorePeerGaugeDataPost(identityToken: string, peerGaugeRequest?: PeerGaugeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PeerGaugeReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scorePeerGaugeDataPost(identityToken, peerGaugeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {PeerHistoryRequest} [peerHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scorePeerHistoryDataPost(identityToken: string, peerHistoryRequest?: PeerHistoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PeerHistoryReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scorePeerHistoryDataPost(identityToken, peerHistoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SGaugeRequest} [sGaugeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreSGaugeDataPost(identityToken: string, sGaugeRequest?: SGaugeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SGaugeReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreSGaugeDataPost(identityToken, sGaugeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SHistoryRequest} [sHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreSHistoryDataPost(identityToken: string, sHistoryRequest?: SHistoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SHistoryReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreSHistoryDataPost(identityToken, sHistoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ScoreApi - factory interface
 * @export
 */
export const ScoreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScoreApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {FetchRequest} [fetchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreFetchDataPost(identityToken: string, fetchRequest?: FetchRequest, options?: any): AxiosPromise<FetchReplay> {
            return localVarFp.scoreFetchDataPost(identityToken, fetchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SGaugeRequest} [sGaugeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreIGaugeDataPost(identityToken: string, sGaugeRequest?: SGaugeRequest, options?: any): AxiosPromise<SGaugeReplay> {
            return localVarFp.scoreIGaugeDataPost(identityToken, sGaugeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SHistoryRequest} [sHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreIHistoryDataPost(identityToken: string, sHistoryRequest?: SHistoryRequest, options?: any): AxiosPromise<SHistoryReplay> {
            return localVarFp.scoreIHistoryDataPost(identityToken, sHistoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {FetchRequest} [fetchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreIScoreFetchPost(identityToken: string, fetchRequest?: FetchRequest, options?: any): AxiosPromise<FetchReplay> {
            return localVarFp.scoreIScoreFetchPost(identityToken, fetchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {PeerGaugeRequest} [peerGaugeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scorePeerGaugeDataPost(identityToken: string, peerGaugeRequest?: PeerGaugeRequest, options?: any): AxiosPromise<PeerGaugeReplay> {
            return localVarFp.scorePeerGaugeDataPost(identityToken, peerGaugeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {PeerHistoryRequest} [peerHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scorePeerHistoryDataPost(identityToken: string, peerHistoryRequest?: PeerHistoryRequest, options?: any): AxiosPromise<PeerHistoryReplay> {
            return localVarFp.scorePeerHistoryDataPost(identityToken, peerHistoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SGaugeRequest} [sGaugeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreSGaugeDataPost(identityToken: string, sGaugeRequest?: SGaugeRequest, options?: any): AxiosPromise<SGaugeReplay> {
            return localVarFp.scoreSGaugeDataPost(identityToken, sGaugeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SHistoryRequest} [sHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreSHistoryDataPost(identityToken: string, sHistoryRequest?: SHistoryRequest, options?: any): AxiosPromise<SHistoryReplay> {
            return localVarFp.scoreSHistoryDataPost(identityToken, sHistoryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScoreApi - object-oriented interface
 * @export
 * @class ScoreApi
 * @extends {BaseAPI}
 */
export class ScoreApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {FetchRequest} [fetchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoreApi
     */
    public scoreFetchDataPost(identityToken: string, fetchRequest?: FetchRequest, options?: AxiosRequestConfig) {
        return ScoreApiFp(this.configuration).scoreFetchDataPost(identityToken, fetchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {SGaugeRequest} [sGaugeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoreApi
     */
    public scoreIGaugeDataPost(identityToken: string, sGaugeRequest?: SGaugeRequest, options?: AxiosRequestConfig) {
        return ScoreApiFp(this.configuration).scoreIGaugeDataPost(identityToken, sGaugeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {SHistoryRequest} [sHistoryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoreApi
     */
    public scoreIHistoryDataPost(identityToken: string, sHistoryRequest?: SHistoryRequest, options?: AxiosRequestConfig) {
        return ScoreApiFp(this.configuration).scoreIHistoryDataPost(identityToken, sHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {FetchRequest} [fetchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoreApi
     */
    public scoreIScoreFetchPost(identityToken: string, fetchRequest?: FetchRequest, options?: AxiosRequestConfig) {
        return ScoreApiFp(this.configuration).scoreIScoreFetchPost(identityToken, fetchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {PeerGaugeRequest} [peerGaugeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoreApi
     */
    public scorePeerGaugeDataPost(identityToken: string, peerGaugeRequest?: PeerGaugeRequest, options?: AxiosRequestConfig) {
        return ScoreApiFp(this.configuration).scorePeerGaugeDataPost(identityToken, peerGaugeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {PeerHistoryRequest} [peerHistoryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoreApi
     */
    public scorePeerHistoryDataPost(identityToken: string, peerHistoryRequest?: PeerHistoryRequest, options?: AxiosRequestConfig) {
        return ScoreApiFp(this.configuration).scorePeerHistoryDataPost(identityToken, peerHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {SGaugeRequest} [sGaugeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoreApi
     */
    public scoreSGaugeDataPost(identityToken: string, sGaugeRequest?: SGaugeRequest, options?: AxiosRequestConfig) {
        return ScoreApiFp(this.configuration).scoreSGaugeDataPost(identityToken, sGaugeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {SHistoryRequest} [sHistoryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoreApi
     */
    public scoreSHistoryDataPost(identityToken: string, sHistoryRequest?: SHistoryRequest, options?: AxiosRequestConfig) {
        return ScoreApiFp(this.configuration).scoreSHistoryDataPost(identityToken, sHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



